export const yandexKey = '4e372f4e-c5f2-47e8-894f-cf8bcf51b7a3';
export const mapDefaultPosition = [44.03929, 43.07084]; // Координаты Северного Кавказа
